
    <wms-dialog-header (onClose)="vcsService.closeDialogWithId('vcsSyncDialog')"
        [title]="locale['LABEL_VCS_MENU_PUSH_PROJECT']"
        [helpLink]="'https://www.wavemaker.com/learn/app-development/dev-integration/developer-collaboration/#push-changes'"></wms-dialog-header>
    <wms-dialog-body>
        <div >
            {{locale.MESSAGE_VCS_PUSH_ON_DEPLOY}}
        </div>
    </wms-dialog-body>
    <wms-dialog-footer>
        <button class="button-secondary btn app-button" role="input" [title]="locale['LABEL_CANCEL']"
            (click)="vcsService.closeDialogWithId('vcsSyncDialog')">
            <span class="btn-caption">{{locale['LABEL_NO']}}</span>
        </button>
        <button class="button-primary btn app-button" role="input" name="wm-vcs-push-changes"
            (click)="openPushDialogWithCallback()" [title]="locale['LABEL_PUSH']"> <span
                class="btn-caption">{{locale['LABEL_YES']}}</span>
        </button>
    </wms-dialog-footer>

